import React, { useState, useEffect } from 'react';
import {
  TableRow,
  TableCell,
  ListItem,
  ListItemText
} from '@material-ui/core';
import { GridSubmitAction } from '@ctsu/ctsu-mui-grid';
import {
  MUISelect, ReactMultiSelect
} from 'components/FormHelpers/FormInputs';
import { useCtxParseValue } from 'helpers';
import { compose } from 'recompose';
import { withAppContext } from '@ctsu/loader';
import _ from 'lodash';
import { withChangeHandlers } from 'helpers/Change';
import { useSelector } from 'react-redux';


const PersonType = ({ state, handleChange, options }) => (
  <MUISelect
    name="personType"
    value={state && state.personType}
    onChange={handleChange}
    validators={['required']}
    errorMessages={['Required Field']}
    title="Person Type"
  >
    { _.map(options, (item, i) => (
      <ListItem
        button
        key={_.uniqueId('open_personType_sel')}
        value={item.enum_str}
      >
        <ListItemText primary={item.enum_str} />
      </ListItem>
    ))}
  </MUISelect>
);

const Mandatory = ({ state, handleChange }) => (
  <MUISelect
    name="isMandatory"
    value={state.isMandatory === true}
    onChange={handleChange}
    title="Mandatory"
  >
    <ListItem button value key="isMandatoryYes">
      <ListItemText primary="Yes" />
    </ListItem>
    <ListItem button value={false} key="isMandatoryNo">
      <ListItemText primary="No" />
    </ListItem>
  </MUISelect>
);

const Multiple = ({ state, handleChange }) => (
  <MUISelect
    name="isMultiple"
    value={state.isMultiple === true}
    onChange={handleChange}
    title="Multiple"
  >
    <ListItem button value key="isMultipleYes">
      <ListItemText primary="Yes" />
    </ListItem>
    <ListItem button value={false} key="isMultipleNo">
      <ListItemText primary="No" />
    </ListItem>
  </MUISelect>
);

const PersonRegistrationTypes = ({ state, setState, options }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [selected, setSelected] = useState(null);
  const isNonIndNonTreat = useSelector(s => s.prtDetails?.prtInfo?.isNonIndNonTreat);

  useEffect(() => {
    let selectables = options.map(el => ({
      ...el,
      value: el.reg_type_cd,
      label: `${el.reg_type_cd}-${el.description}`,
      personRegistrationType: el.reg_type_cd
    }));
    // PROT-140 show NINT-Non-IND Non-Treatment selection only if the protocol isNonIndNonTreat
    if (!isNonIndNonTreat) {
      selectables = selectables.filter(f => !f.label.includes('NINT-Non-IND Non-Treatment'))
    } 
    setSuggestions(selectables);
  }, [setSuggestions, options, isNonIndNonTreat]);

  useEffect(() => {
    const inputGrp = (state && state.openProtPerRegTypeXrefs)
      ? state.openProtPerRegTypeXrefs
      : null;
    setSelected(inputGrp && _.map(inputGrp, item => ({
      ...item,
      label: `${item.personRegistrationType}-${item.description}`,
      value: item.personRegistrationType
    })));
  }, [setSelected, state]);

  return (
    <ReactMultiSelect
      title="Person Registration Types"
      name="participantGroup"
      isClearable
      validators={['required']}
      errorMessages={['Required Field']}
      options={suggestions}
      value={selected}
      onChange={event => {
        setSelected(event);
        setState({ ...state, openProtPerRegTypeXrefs: event });
      }}
    />
  );
};

const Status = ({ state, handleChange }) => (
  <MUISelect
    name="esysStatus"
    value={state.esysStatus || 'ACTIVE'}
    onChange={handleChange}
    title="Status"
  >
    <ListItem button value="ACTIVE">
      <ListItemText primary="ACTIVE" />
    </ListItem>
    <ListItem button value="INACTIVE">
      <ListItemText primary="INACTIVE" />
    </ListItem>
  </MUISelect>
);

const EditOpenPersonTypesCmp = (props) => {
  const {
    cancel, reset, state, setState, handleChange
  } = props;
  const { protocolOPENPersonRegType } = useCtxParseValue('LOV_OPEN_SETUP_PERSON_REG_TYPE');
  const { protocolOPENPersonType } = useCtxParseValue('LOV_OPEN_SETUP_PERSON_TYPE');
  return (
    <TableRow>
      <TableCell>
        <PersonType
          state={state}
          handleChange={handleChange}
          options={protocolOPENPersonType}
        />
      </TableCell>
      <TableCell>
        <Mandatory
          state={state}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <Multiple
          state={state}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <PersonRegistrationTypes
          state={state}
          setState={setState}
          options={protocolOPENPersonRegType}
        />
      </TableCell>
      <TableCell>
        <Status
          state={state}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell align="center">
        <GridSubmitAction
          cancel={cancel}
          reset={reset}
        />
      </TableCell>
    </TableRow>
  );
};

const EditGroupOpenPersonTypes = compose(
  withAppContext,
  withChangeHandlers
)(EditOpenPersonTypesCmp);

export default EditGroupOpenPersonTypes;
